var map = {
	"./bg-arabic.mp4": 9510,
	"./bg-mobile-arabic.mp4": 5219,
	"./bg-mobile.mp4": 7882,
	"./bg.mp4": 8168,
	"./security-arabic.mp4": 7195,
	"./security-mobile-arabic.mp4": 5558,
	"./security-mobile.mp4": 1610,
	"./security.mp4": 6468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4081;